import { MoreVertRounded } from '@mui/icons-material';
import { Box, IconButton, IconButtonProps, MenuProps } from '@mui/material';
import { useState } from 'react';
import { KebabMenuList } from './KebabMenuList';
import { MenuItemOptions } from './types';

interface KebabMenuProps {
  menuItems: MenuItemOptions;
  buttonProps?: IconButtonProps;
  menuProps?: Omit<MenuProps, 'open'>;
  onOpen?: () => void;
  onClose?: () => void;
}

export const KebabMenu = ({
  menuItems,
  buttonProps,
  menuProps,
  onOpen,
  onClose,
}: KebabMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  if (menuItems.length === 0) {
    return null;
  }

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    onOpen?.();
  };

  const handleClose = () => {
    setAnchorEl(null);
    onClose?.();
  };

  return (
    <Box>
      <IconButton onClick={handleOpen} {...buttonProps}>
        <MoreVertRounded />
      </IconButton>
      <KebabMenuList
        anchorEl={anchorEl}
        onMenuClose={handleClose}
        menuItems={menuItems}
        menuProps={menuProps}
      />
    </Box>
  );
};
